import { debounce } from "debounce";

const TableOfContents = () => {
  const tocs = document.querySelectorAll(".element--table-of-contents");
  tocs.forEach((toc) => {
    toc.remove();
  });

  // automatically disables a table of contents if [data-toc] is enabled and
  // multiple headings found
  const sections = document.querySelectorAll("[data-toc]");
  const base = window.location.href.split("#")[0];
  const icon =
    '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.3 13.125L12.7 19.725C12.6 19.825 12.4916 19.896 12.375 19.938C12.2583 19.9793 12.1333 20 12 20C11.8666 20 11.7416 19.9793 11.625 19.938C11.5083 19.896 11.4 19.825 11.3 19.725L4.69996 13.125C4.51663 12.9417 4.42063 12.7127 4.41196 12.438C4.40396 12.1627 4.49996 11.925 4.69996 11.725C4.88329 11.525 5.11229 11.4207 5.38696 11.412C5.66229 11.404 5.89996 11.5 6.09996 11.7L11 16.6V5.425C11 5.14167 11.0956 4.904 11.287 4.712C11.479 4.52067 11.7166 4.425 12 4.425C12.2833 4.425 12.5206 4.52067 12.712 4.712C12.904 4.904 13 5.14167 13 5.425L13 16.6L17.9 11.7C18.0833 11.5167 18.3166 11.4207 18.6 11.412C18.8833 11.404 19.1166 11.5 19.3 11.7C19.5 11.8833 19.6 12.1167 19.6 12.4C19.6 12.6833 19.5 12.925 19.3 13.125Z" fill="currentColor"/></svg>';
  if (sections) {
    const appendHeadingToList = (heading, list) => {
      const li = document.createElement("li");
      const a = document.createElement("a");
      a.href = heading.href;
      a.classList.add("table-of-contents__link");
      a.innerText = heading.text;

      a.insertAdjacentHTML("afterbegin", icon);

      li.appendChild(a);
      list.appendChild(li);
    };

    sections.forEach((section) => {
      const headings = section.querySelectorAll("h2");
      if (headings.length > 2) {
        let includeHeadings = [];

        // append all the headers
        headings.forEach((heading, i) => {
          if (!heading.innerHTML) {
            return;
          }

          if (heading.classList.contains("no--anchor")) {
            return;
          }

          // if heading is within data-toc-ignore, skip
          if (heading.closest("[data-toc-ignore]")) {
            return;
          }

          // if no heading id, create one
          if (!heading.getAttribute("id")) {
            heading.setAttribute(
              "id",
              "toc_" +
                heading.innerText.toLowerCase().replace(/[^a-z0-9]/g, "-") +
                "_" +
                i
            );
          }

          includeHeadings.push({
            href: `${base}#${heading.getAttribute("id")}`,
            text: heading.innerText,
          });
        });

        if (includeHeadings.length == 0) {
          return;
        }

        const toc = document.createElement("div");
        toc.classList.add("table-of-contents");
        toc.classList.add("no-print");
        toc.setAttribute("data-glossary-ignore", "true");
        toc.innerHTML = `<h3 class="h5">On this page</h3><div class="table-of-contents__lists"><ul></ul></div>`;

        if (includeHeadings.length < 4 || window.innerWidth < 1025) {
          // a single list on mobile or if there are less than 4 headings
          includeHeadings.forEach((heading) => {
            appendHeadingToList(heading, toc.querySelector("ul"));
          });
        } else {
          toc.classList.add("desktop__two-columns");
          toc.querySelector("ul")?.classList.add("first");

          // split into two lists
          const ul = document.createElement("ul");
          ul.classList.add("second");
          toc.querySelector(".table-of-contents__lists").appendChild(ul);

          includeHeadings.forEach((heading, i) => {
            // if i is even then append to the first list, otherwise append to the second
            if (i % 2 == 0) {
              appendHeadingToList(heading, toc.querySelector("ul.first"));
            } else {
              appendHeadingToList(heading, toc.querySelector("ul.second"));
            }
          });
        }

        const element = document.createElement("div");
        element.classList.add("element");
        element.classList.add("element--table-of-contents");

        // prepend the table of contents to either after
        // .block-content-page__overview in the section or at the top
        const overview = section.querySelector(".block-content-page__overview");

        element.innerHTML = toc.outerHTML;

        if (overview) {
          toc.classList.add("space-top-4");
          overview.after(element);
        } else {
          // no overview, make sure it goes after '`inner__sidebar` if present
          const sidebar = section.querySelector(".inner__sidebar");
          if (sidebar) {
            sidebar.after(element);
          } else {
            section.prepend(element);
          }
        }
      }
    });
  }

  // listen to any .table-of-contents__link click on both and smooth scroll
  document.addEventListener("click", (e) => {
    if (!e.target) {
      return;
    }

    const link = e.target.closest(".table-of-contents__link");
    if (link) {
      e.preventDefault();
      const id = link.getAttribute("href").split("#")[1];
      const element = document.getElementById(id);
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  });
};

// on window resize, since we move from 1 to two columns then we may need to
// redo the toc
const debouncedTable = debounce(() => {
  TableOfContents();
}, 5);

window.addEventListener("resize", () => {
  debouncedTable();
});

export default TableOfContents;
